import { SdSearchDto, useSafetyDeviceSearchApi } from "~/api/GeneratedApi";
import { useCustomQuery } from "~/utils/hooks/useCustomQuery";

// type QueryOptions = unknown;
type UseSecurityDeviceSearchOptions = { options?: SdSearchDto | undefined };
export const useSecurityDeviceSearch = ({
  options,
}: UseSecurityDeviceSearchOptions = {}) => {
  const { sdSearch } = useSafetyDeviceSearchApi();

  const {
    data: atonUnits,
    isLoading: loadingUnits,
    isFetching: fetchingUnits,
  } = useCustomQuery(
    { key: "aton-units-search", dto: options as SdSearchDto },
    () => sdSearch(options as SdSearchDto),
    { enabled: options !== undefined },
  );

  return { atonUnits, loadingUnits, fetchingUnits };
};
